import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";
//import menuBg from "../assets/demo.jpg";
import logo from "../assets/Logo.png"

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = ["Home", "Events", "Sponsors", "About", "Certificate"];

  const handleNavClick = (id) => {
    setMenuOpen(false);
     if (id === "certificate") {
      // Navigate to certificate route directly
      navigate("/certificate");
      return;
    }

    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (location.pathname === "/" && location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
        window.history.replaceState({}, document.title);
      }
    }
  }, [location]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <nav className="site-navbar" role="navigation">
      <div className="logo">
  <img src={logo} alt="Logo" className="logo-img" />
</div>

      {/* Desktop Nav - Only show when menu is NOT open */}
      {!menuOpen && (
        <ul className="nav-links">
          {navItems.map((item, idx) => (
            <li key={idx}>
               {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                onClick={() => handleNavClick(item.toLowerCase())}
                className="nav-button"
              >
                {item}
              </a>
            </li>
          ))}
        </ul>
      )}

      {/* Hamburger Icon */}
      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={handleMenuToggle}
        aria-label="Menu Toggle"
        aria-expanded={menuOpen}
        role="button"
        tabIndex={0}
      >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div
          className="overlay"
          onClick={() => setMenuOpen(false)}
          style={{ 
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
          }}
        >
          <div className="mobile-menu-panel" onClick={(e) => e.stopPropagation()}>
            <ul className="overlay-menu">
            {navItems.map((item, idx) => (
              <li key={idx}>
                 {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                  className="btn neon-btn"
                  onClick={() => handleNavClick(item.toLowerCase())}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
